import { env } from "@/env";

export type GeoLocation = {
  city: string;
  country: string;
  region: string;
};

export const getLocation = async (): Promise<GeoLocation> => {
  const functionUrl = `https://${env.NEXT_PUBLIC_FIREBASE_DOMAIN}/geolocation`;
  const response = await fetch(functionUrl, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({}),
  });

  if (!response.ok) {
    throw new Error("Network response was not ok");
  }

  const result = await response.json();

  return {
    region: result.data.region,
    country: result.data.country,
    city: result.data.city,
  };
};
